export default __webpack_public_path__ + "static/google-cf688b832fcbc3a1e12502ceedfc6f00.png";